import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {VehicleTransaction} from '../../models/vte';
import {VehicleTransactionViewService} from '../../services/vte/vehicle-transaction-view.service';
import {ProviderEventViewService} from '../../services/vte/provider-event-view.service';
import {VteApiService} from '../../services/vte/vte-api.service';
import {ActivityTimelineComponent} from '../../shared/activity-timeline/activity-timeline.component';
import {
    AnalyticsFactRendererComponent,
    InspectionOutcomeBadgeComponent,
    MetadataPanelComponent,
    OperationsBackLinkComponent,
    OperationalAttentionBadgeComponent,
    TransactionStatusBadgeComponent,
} from '../../shared/vte';

@Component({
    selector: 'app-vehicle-transaction-detail',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        ActivityTimelineComponent,
        MetadataPanelComponent,
        OperationsBackLinkComponent,
        TransactionStatusBadgeComponent,
        OperationalAttentionBadgeComponent,
        InspectionOutcomeBadgeComponent,
        AnalyticsFactRendererComponent,
    ],
    templateUrl: './vehicle-transaction-detail.component.html',
    styleUrl: './vehicle-transaction-detail.component.css',
})
export class VehicleTransactionDetailComponent implements OnInit {
    transaction: VehicleTransaction | null = null;
    loading = true;
    loadError = false;
    backLinkQueryParams: Record<string, string> = {};

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private vteApi: VteApiService,
        public transactionView: VehicleTransactionViewService,
        public providerEventView: ProviderEventViewService,
    ) {
    }

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((queryParams) => {
            const next: Record<string, string> = {};
            queryParams.keys.forEach((key) => {
                const value = queryParams.get(key);
                if (value) {
                    next[key] = value;
                }
            });
            this.backLinkQueryParams = next;
        });
        this.route.paramMap.subscribe((params) => {
            const transactionId = params.get('id');
            if (!transactionId) {
                this.router.navigate(['/operations/transactions']);
                return;
            }
            this.loadTransaction(transactionId);
        });
    }

    loadTransaction(transactionId: string): void {
        this.loading = true;
        this.loadError = false;
        this.transaction = null;
        this.vteApi.getVehicleTransaction(transactionId).pipe(
            finalize(() => {
                this.loading = false;
            }),
        ).subscribe({
            next: (transaction) => {
                this.transaction = transaction;
            },
            error: () => {
                this.transaction = null;
                this.loadError = true;
            },
        });
    }

    get timelineActivities() {
        return this.transaction ? this.transactionView.buildTimeline(this.transaction) : [];
    }

    get timelineCurrentIndex() {
        return this.transaction
            ? this.transactionView.getCurrentTimelineIndex(this.transaction, this.timelineActivities)
            : -1;
    }

    get analyticsFacts() {
        return this.transaction ? this.transactionView.buildAnalyticsFacts(this.transaction) : [];
    }

    get relatedRecordLinks() {
        return this.transaction ? this.transactionView.buildRelatedRecordLinks(this.transaction) : [];
    }
}
